<template>
  <v-app>
    <v-app-bar elevation="0" class="stdtf-navbar">
      <v-container fluid>
        <v-row align="center" justify="space-between" no-gutters>
          <v-col cols="auto" class="d-flex align-center">
            <v-img
              :src="require('@/assets/logo.png')"
              class="mr-3 hidden-sm-and-down"
              contain
              height="38px"
              width="38px"
            />
            <span class="text-subtitle-1 font-weight-bold text-primary hidden-sm-and-down">
              Scam Takedown Task Force
            </span>
          </v-col>
          <v-col cols="auto">
            <v-btn variant="text" to="/" exact>Home</v-btn>
            <v-btn variant="text" to="/about">About</v-btn>
            <v-btn variant="text" to="/updates">News</v-btn>
            <v-btn variant="tonal" color="primary" to="/support" class="ml-2">Support Us</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup>
</script>

<style>
.stdtf-navbar {
  background-color: rgba(8, 12, 23, 0.95) !important;
  border-bottom: 1px solid rgba(0, 212, 255, 0.12) !important;
  backdrop-filter: blur(12px);
}
</style>
